;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.FiltersParams =  Backbone.Collection.extend({
		cost: [
			{
				name: 'Price',
				value: '0-9000'
			},
			{
				name: '< 200K',
				value: '0-200'
			},
			{
				name: '200-300K',
				value: '200-300'
			},
			{
				name: '300k-400K',
				value: '300-400'
			},
			{
				name: '400k-500K',
				value: '400-500'
			},
			{
				name: '> 500k',
				value: '500-9000'
			}
		],

		status: [
			{
				name: 'All Statuses',
				value: 'all'
			},
			{
				name: 'Available',
				value: 'available'
			},
			{
				name: 'Unavailable',
				value: 'unavailable'
			}
		],

		order_by: [
			{
				name: 'Price ($)',
				value: 'cost'
			},
			{
				name: 'Average (AVG)',
				value: 'stats.avg_points'
			},
			{
				name: 'Total points (TOT)',
				value: 'stats.total_points'
			},
			{
				name: 'Points Last Round (RD N)',
				value: 'last_points'
			},
			{
				name: 'Selected by % (TS%)',
				value: 'stats.owned_by'
			},
			{
				name: '$ / Points ($/PTS)',
				value: 'dollar_points'
			},
			{
				name: 'Form (L3 AVG)',
				value: 'stats.last_3_avg'
			}
		]
	});

}(window, APP, Backbone, Marionette, $, _));